module.exports = __webpack_public_path__ + "static/media/photo.ee8d6da3.svg";